'use client';

import React from 'react';
import cx from 'clsx';

import { useGoBack } from '~/app/hooks';
import { changedByFontScale } from '~/utils/fontScale';

import { AppBar } from './components/AppBar';

type Props = React.PropsWithChildren<
  React.ComponentProps<typeof AppBar> & { className?: string }
>;

export function AppLayout({ className, children, ...appBarProps }: Props) {
  const goBack = useGoBack();

  return (
    <>
      <AppBar onLeftClick={goBack} {...appBarProps} />
      <section
        className={cx(
          'm-auto max-w-3xl bg-gray-000 ios-safe-bottom',
          className,
          changedByFontScale() && 'overflow-x-hidden',
        )}
      >
        {children}
      </section>
    </>
  );
}
